/**
 * Picture display rules:
 * - vehicle_search_result true  => mode véhicule : photos véhicule, puis picture_url, puis catégorie
 * - vehicle_search_result false => mode catégorie : photos catégorie uniquement
 */

export function isVehicleSearchResultMode(vehicleSearchResult) {
    if (vehicleSearchResult === true || vehicleSearchResult === 1) {
        return true;
    }

    // Certains contextes renvoient la valeur sous forme de string.
    if (typeof vehicleSearchResult === 'string') {
        const normalized = vehicleSearchResult.trim().toLowerCase();
        return normalized === '1' || normalized === 'true';
    }

    return false;
}

export function normalizeVehicleImageUrl(url) {
    if (!url || typeof url !== 'string') {
        return url;
    }

    // Les URLs S3 peuvent arriver en protocol-relative: //bucket/key.
    let normalized = url.trim();
    if (normalized.startsWith('//')) {
        normalized = `https:${normalized}`;
    }
    // Corrige les URLs de type https:///bucket/key sans toucher au protocole.
    normalized = normalized.replace(/^(https?:\/\/)\/+/, '$1');
    return normalized;
}

export function mapPictureItemsToUrls(items) {
    // Les APIs ne renvoient pas toutes le même champ selon la source de l'image.
    return (items ?? [])
        .map((picture) => picture?.medium_url ?? picture?.large_url ?? picture?.url ?? picture?.small_url ?? picture?.square_url)
        .filter(Boolean)
        .map((url) => normalizeVehicleImageUrl(url))
        .map((url) => ({ url }));
}

/**
 * @param {object} params
 * @param {unknown} params.vehicleSearchResult
 * @param {Array|undefined} params.vehiclePictures
 * @param {Array|undefined} params.categoryPictures
 * @param {string|undefined} params.pictureUrlFallback
 * @returns {Array<{url: string}>}
 */
export function getDisplayPictures({
    vehicleSearchResult,
    vehiclePictures,
    categoryPictures,
    pictureUrlFallback,
}) {
    const vehicleItems = mapPictureItemsToUrls(vehiclePictures);
    const categoryItems = mapPictureItemsToUrls(categoryPictures);

    // Mode catégorie (vehicle_search_result = false/0) : ignorer vehicle.pictures.
    if (!isVehicleSearchResultMode(vehicleSearchResult)) {
        return categoryItems;
    }

    // Mode véhicule (vehicle_search_result = true/1) : priorité aux photos véhicule.
    if (vehicleItems.length > 0) {
        return vehicleItems;
    }
    if (pictureUrlFallback) {
        return [{ url: normalizeVehicleImageUrl(pictureUrlFallback) }];
    }
    return categoryItems;
}
